import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "./component/Header";
import SideNavigation from "./component/SideNavigation";
import { ROLE_ROUTE_MAP } from "./utils/constant";
import { getToken } from "./utils/localStorageMethods";
import { useState } from "react";

const ProtectedRoute = ({ children, roles }) => {
  const location = useLocation();
  const token = getToken();
  const { user } = useSelector((state) => state.UserReducer);

  // On mobile (≤991px) sidebar should start hidden; on desktop start expanded
  const [isCollapsed, setIsCollapsed] = useState(
    () => window.innerWidth <= 991,
  );

  // Public route (roles = null)
  if (roles === null) return children;

  // Not logged in → redirect to login (subdomain determines which login is shown)
  if (!token || !user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  const userRole = user?.role;

  // User role not allowed
  if (roles && !roles.includes(userRole)) {
    const fallbackRoute = ROLE_ROUTE_MAP[userRole] || "/404";
    return <Navigate to={fallbackRoute} replace />;
  }

  // Allowed → show layout + page
  return (
    <>
      <div
        className={`layout ${
          isCollapsed ? "sidebar-collapsed" : "sidebar-expanded"
        }`}
      >
        <SideNavigation
          isCollapsed={isCollapsed}
          setCollapsedFromSidebar={(value) => setIsCollapsed(value)}
        />

        <div className="content-area">
          <Header
            isCollapsed={isCollapsed}
            onToggleSidebar={() => setIsCollapsed((prev) => !prev)}
          />
          {/* Scrollable area */}
          <div className="content-scroll">
            <div className="content">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProtectedRoute;

// const ProtectedRoute = ({ children, userType }) => {
//   const location = useLocation();
//   const token = getToken();
//   const { user } = useSelector((state) => state.UserReducer);

//   if (!token || !user) {
//     return <Navigate to="/" state={{ from: location }} replace />;
//   }

//   if (user?.role === userType) {
//     return children;
//   }

//   switch (user?.role) {
//     case "school":
//       return <Navigate to="/school-dashboard" state={{ from: location }} replace />;
//     case "super_admin":
//       return <Navigate to="/admin/dashboard" state={{ from: location }} replace />;
//     default:
//       return <Navigate to="/dashboard" state={{ from: location }} replace />;
//   }
// };
